<section class="experience_section">
    <div class="home__container containerPersonal grid">
        <div class="home__content grid">

            <div class="home__data">
                <h1 class="home__title">
                    Nuestra Experiencia
                </h1>
                <div class="card-container">

                    <a class="card" target="_blank" rel="noopener" href="#">
                        <div class="card-content">
                            <header class="z-10 text-xs font-semibold uppercase tracking-wide text-slate-500"
                                aria-label="2021 to Present">2021 — Presente
                            </header>
                            <div class="description">
                                <span class="position">Desarrollo de Sistemas Biométricos</span>
                                <span class="company">Sector Financiero y Seguridad</span>
                                <h3 class="home__subtitle">
                                    <span>Especialistas en la implementación de interfaces de usuario para sistemas biométricos, 
                                    integrando autenticación facial y de huellas dactilares en aplicaciones web. Desarrollo 
                                    de APIs RESTful y microservicios con Spring Boot, así como algoritmos para procesar y 
                                    autenticar datos biométricos. Enfoque en seguridad de datos mediante encriptación, 
                                    gestión de usuarios y prácticas de codificación segura.</span>
                                </h3>

                                <div class="tech-stack">
                                    <span class="tech-item">JAVA</span>
                                    <span class="tech-item">HTML</span>
                                    <span class="tech-item">CSS</span>
                                    <span class="tech-item">JavaScript</span>
                                    <span class="tech-item">TypeScript</span>
                                    <span class="tech-item">Angular</span>
                                    <span class="tech-item">Node.js</span>
                                    <span class="tech-item">Spring Boot</span>
                                    <span class="tech-item">MySQL</span>
                                    <span class="tech-item">SQL Server</span>
                                    <span class="tech-item">AWS</span>
                                </div>
                            </div>
                        </div>
                    </a>
                    
                    <a class="card" target="_blank" rel="noopener" href="#">
                        <div class="card-content">
                            <header class="z-10 text-xs font-semibold uppercase tracking-wide text-slate-500"
                                aria-label="2020 to 2021">2020 — 2021
                            </header>
                            <div class="description">
                                <span class="position">Transformación Digital Empresarial</span>
                                <span class="company">Sector Comercial y Logística</span>
                                <h3 class="home__subtitle">
                                    <span>Desarrollo de interfaces Angular para gestión de contratos y documentos, 
                                    mejorando la experiencia del usuario y eficiencia de sistemas internos. Diseño 
                                    de portales para distribución de minerales y pagos, gestión de bases de datos 
                                    Microsoft SQL con procedimientos almacenados. Implementación de sistemas de alertas 
                                    para fechas clave de contratos y optimización de logística de envíos.</span>
                                </h3>
                                <div class="tech-stack">
                                    <span class="tech-item">Node.js</span>
                                    <span class="tech-item">Angular</span>
                                    <span class="tech-item">Express.js</span>
                                    <span class="tech-item">Nest.js</span>
                                    <span class="tech-item">SQL Server</span>
                                    <span class="tech-item">Azure</span>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a class="card" target="_blank" rel="noopener" href="#">
                        <div class="card-content">
                            <header class="z-10 text-xs font-semibold uppercase tracking-wide text-slate-500"
                                aria-label="2019">2019 — 2020
                            </header>
                            <div class="description">
                                <span class="position">Automatización Industrial</span>
                                <span class="company">Sector Agroindustrial</span>
                                <h3 class="home__subtitle">
                                    <span>Mantenimiento de equipos, modelado y diseño de piezas mecánicas, así como 
                                    pruebas de funcionalidad por software e implementación. Conexión electrónica entre 
                                    microcontroladores y sensores para sistemas de automatización industrial. Aplicación 
                                    de tecnologías IoT para monitoreo y control de procesos.</span>
                                </h3>
                                <div class="tech-stack">
                                    <span class="tech-item">SolidWork</span>
                                    <span class="tech-item">AutoCAD</span>
                                    <span class="tech-item">IoT</span>
                                    <span class="tech-item">Python</span>
                                    <span class="tech-item">MATLAB</span>
                                </div>
                            </div>
                        </div>
                    </a>

                </div>
            </div>
        </div>

    </div>
</section>